import { getApiClient } from './authApiClient';
import { getSupportPreviewUserId } from '../utils/supportPreview';

const base = tenantId => {
  if (!tenantId) throw new Error('Select a tenant before loading insurance assessments.');
  return `/integrated-dcl/tenants/${encodeURIComponent(tenantId)}`;
};
const policy = (tenantId, id) => `${base(tenantId)}/policies/${encodeURIComponent(id)}`;
const client = () => {
  const api = getApiClient('company');
  const preview = getSupportPreviewUserId(typeof window === 'undefined' ? '' : window.location.search);
  if (!preview) return api;
  const config = options => ({ ...options, params: { ...options?.params, viewAsUser: preview } });
  return {
    get: (url, options) => api.get(url, config(options)),
    post: (url, body, options) => api.post(url, body, config(options)),
    put: (url, body, options) => api.put(url, body, config(options)),
  };
};
const data = response => {
  if (response.data?.success === false) throw new Error(response.data.message || 'Insurance operation could not be confirmed.');
  return response.data?.data;
};
export const getIntegratedDclCapabilities = async tenantId => data(await client().get(`${base(tenantId)}/capabilities`));
export const listIntegratedDclPolicies = async tenantId => data(await client().get(`${base(tenantId)}/policies`));
export const getIntegratedDclPolicy = async (tenantId, id) => data(await client().get(policy(tenantId, id)));
export const createIntegratedDclPolicy = async (tenantId, payload) => data(await client().post(`${base(tenantId)}/policies`, payload));
export const uploadIntegratedDclPolicySource = async (tenantId, id, file, { expectedRevision } = {}) => data(await client().post(`${policy(tenantId, id)}/source`, file, {
  params: { expectedRevision }, headers: { 'Content-Type': file.type || (file.name?.toLowerCase().endsWith('.pdf') ? 'application/pdf' : 'text/plain') },
}));
export const getIntegratedDclPolicySource = async (tenantId, id) => data(await client().get(`${policy(tenantId, id)}/source`));
export const saveIntegratedDclPolicyDraft = async (tenantId, id, payload) => data(await client().put(`${policy(tenantId, id)}/draft`, payload));
export const reviewIntegratedDclPolicy = async (tenantId, id, payload) => data(await client().post(`${policy(tenantId, id)}/review`, payload));
export const activateIntegratedDclPolicy = async (tenantId, id, payload) => data(await client().post(`${policy(tenantId, id)}/activate`, payload));
export const getIntegratedDclAssessment = async (tenantId, companyId) => data(await client().get(`${base(tenantId)}/companies/${encodeURIComponent(companyId)}/assessment`));
export const getIntegratedDclAssessments = async (tenantId, companyIds) => data(await client().get(`${base(tenantId)}/assessments`, { params: { companyIds: companyIds.join(',') } }));
export const reassessIntegratedDclCompany = async (tenantId, companyId) => data(await client().post(`${base(tenantId)}/companies/${encodeURIComponent(companyId)}/reassess`, {}));
const carrierLimitRequest = (tenantId, companyId) => {
  if (!companyId) throw new Error('Select a company before reviewing an insurer limit request.');
  return `${base(tenantId)}/companies/${encodeURIComponent(companyId)}/carrier-limit-request`;
};
export const previewCarrierLimitRequest = async (tenantId, companyId) => data(await client().post(`${carrierLimitRequest(tenantId, companyId)}/preview`, {}));
export const sendCarrierLimitRequest = async (tenantId, companyId, payload) => data(await client().post(`${carrierLimitRequest(tenantId, companyId)}/send`, payload));
export const getCarrierLimitRequestStatus = async (tenantId, companyId, requestId) => {
  if (!requestId) throw new Error('A request identity is required to check its status.');
  return data(await client().get(`${carrierLimitRequest(tenantId, companyId)}/${encodeURIComponent(requestId)}`));
};
